import type { SearchQueryBody } from "@/types";

export type EventsRequest = Partial<{
  datasetIds: string[];
  fileIds: string[];
  topicIds: string[];
  messagePathIds: string[];
}>;

/**
 * Query key factory for event queries. Mirrors `datasetQueryKeys` so list
 * reads and any future mutation invalidations stay aligned.
 */
export const eventQueryKeys = {
  all: ["events"] as const,
  lists: () => [...eventQueryKeys.all, "list"] as const,
  list: (orgId: string | undefined, query?: SearchQueryBody) =>
    query
      ? ([...eventQueryKeys.lists(), orgId, query] as const)
      : ([...eventQueryKeys.lists(), orgId] as const),
  details: () => [...eventQueryKeys.all, "detail"] as const,
  detail: (id: string) => [...eventQueryKeys.details(), id] as const,
  forDatasets: () => [...eventQueryKeys.all, "datasets"] as const,
  forDataset: (id: string) => [...eventQueryKeys.forDatasets(), id] as const,
  forWorkspaces: () => [...eventQueryKeys.all, "workspace"] as const,
  forWorkspace: (request: EventsRequest) =>
    [
      ...eventQueryKeys.forWorkspaces(),
      JSON.stringify({
        ...(request.datasetIds && { datasets: [...request.datasetIds].sort() }),
        ...(request.fileIds && { files: [...request.fileIds].sort() }),
        ...(request.topicIds && { topics: [...request.topicIds].sort() }),
        ...(request.messagePathIds && {
          messagePaths: [...request.messagePathIds].sort(),
        }),
      }),
    ] as const,
};
